module.exports = __webpack_public_path__ + "media/company1.4eaeffca.mp4";